import type { MetricKey } from "../types";

import { Typo } from "../../Typo";
import { usePerformanceReportTranslations } from "../hooks/usePerformanceReportTranslations";
import { usePerformanceReportContext } from "../providers/PerformanceReportProvider";

/**
 * The mobile row list's column header: the active dimension on the left, the
 * currently sorted metric on the right.
 *
 * Deliberately a separate component from `MobileRowList` so the page can render
 * it *outside* the loading / error / empty branch. The design canvas keeps
 * `.m-dhead` outside that conditional too, which is what satisfies the AC's
 * "the row list preserves its header" for both state variants — its labels come
 * from translations and sort state, never from the API response, so there is
 * nothing to wait for.
 */
export const MobileRowListHeader = () => {
  const translations = usePerformanceReportTranslations();
  const { tab, sorting } = usePerformanceReportContext();

  const metricKey = (sorting[0]?.id ?? "clicks") as MetricKey;
  const metricCol = translations.metricColumns.find((c) => c.key === metricKey);
  const clicksLabel = translations.metricColumns.find(
    (c) => c.key === "clicks",
  )?.label;

  return (
    <div className="flex items-center justify-between gap-3 pb-1">
      <Typo element="span" type="captionXS" textColor="text-text-secondary">
        {translations.sourceColumnLabels[tab]}
      </Typo>
      <Typo element="span" type="captionXS" textColor="text-text-secondary">
        {metricCol?.label ?? clicksLabel}
      </Typo>
    </div>
  );
};
